<template>
  <card
    class="player-card"
    :bodyClasses="['body', {'closed': !expanded}]"
    shadow
  >
    <div slot="header" class="row">
        <div class="col d-flex align-items-center" @click="expanded = !expanded">
          <h3 class="mb-0" v-if="model.teams.length <= 0">
            New Match
          </h3>
          <h3 class="mb-0" v-if="model.teams.length >= 1">
            {{model.teams[0].Name}}
            <span class="light-text" v-if="model.teams.length > 1">
              <i> vs. </i>
            </span>
            {{model.teams.length >= 2 ? model.teams[1].Name : ''}}
          </h3>
          <badge :type="status.type" class="status-badge">{{status.text}}</badge>
        </div>
        <div class="col-auto text-right d-flex align-items-center justify-content-end">
          <i class="fa fa-trash delete-icon" @click="onRemove"/>
          <i class="fa fa-chevron-down expand-icon" v-if="!expanded" @click="expanded = !expanded"/>
          <i class="fa fa-chevron-up expand-icon" v-else @click="expanded = !expanded"/>
        </div>
      </div>

    <div class="row">
      <div class="col-md-6">
        <base-input
          label="Match Date / Time"
          alternative=""
        >
          <flat-picker
            slot-scope="{focus, blur}"
            @on-open="focus"
            @on-close="blur"
            :config="{
              allowInput: true,
              enableTime: true,
              dateFormat: 'Z',
              altInput: true,
              altFormat: 'D. M. j at h:i K',
            }"
            class="form-control form-control-alternative datepicker"
            v-model="model.matchDateTime"
            placeholder="YYYY-MM-DD HH:MM"
          />
        </base-input>
      </div>
      <div class="col-md-6">
        <base-input
          label="Simulator"
        >
          <Multiselect
            v-model="model.simulator"
            :options="sims"
            class="shadow"
            track-by="id"
            label="name"
          />
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="form-control-label teams-label">Teams</label>
        <div class="drop-grid">
          <div :class="['drop-guides', { single }]">
            <span :class="['child', {'occupied': model.teams.length > 0}]">Drag Team Here</span>
            <span
              :class="['child', {'occupied': model.teams.length > 1}]"
              v-if="!single"
            >
              Drag Team Here
            </span>
          </div>
          <draggable
            :class="['team-drop-zone', { single }]"
            v-model="model.teams"
            :group="{name: 'teams', put: canDrop}"
          >
            <TeamScheduleCard
              class="team-object"
              v-for="team in model.teams"
              :team="team"
              :key="'team'+team.id"
              :week="week"
            />
          </draggable>
        </div>
      </div>
    </div>

  </card>
</template>
<script>
import flatPicker from 'vue-flatpickr-component';
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';
import TeamScheduleCard from '@/components/TeamScheduleCard.vue';
import 'flatpickr/dist/flatpickr.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import ErrorHandler from '@/helpers/AuthError';

export default {
  components: {
    flatPicker,
    Multiselect,
    draggable,
    TeamScheduleCard,
  },
  props: {
    value: {
      type: Object,
    },
    week: {
      type: Object,
    },
    single: {
      type: Boolean,
    },
  },
  data() {
    return {
      model: {
        matchDateTime: this.week ? this.week.Start : null,
        simulator: null,
        teams: [],
        id: null,
      },
      expanded: true,
    };
  },
  mounted() {
    this.$store.dispatch('getSimulators');
    this.setModelToMatch();
    if (this.model.id) {
      this.expanded = false;
    }
  },
  watch: {
    value() {
      console.log(this.value);
      if (!this.editing) {
        this.setModelToMatch();
      }
    },
  },
  computed: {
    originalState: {
      get() {
        if (!this.value) {
          return {
            matchDateTime: this.week ? this.week.Start : null,
            simulator: null,
            teams: [],
            id: null,
          };
        }
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sims() {
      return this.$store.state.simulators;
    },
    editing() {
      if (
        this.model.matchDateTime !== this.originalState.matchDateTime
        || this.model.simulator.id !== this.originalState.simulator.id
        || this.model.teams !== this.originalState.teams
      ) {
        return true;
      }
      return false;
    },
    status() {
      console.log(this.model);
      if (this.model.id === null || this.model.id === '') {
        return {
          text: 'UNSAVED',
          type: 'warning',
        };
      }
      if (
        this.model.matchDateTime !== this.originalState.matchDateTime
        || (this.model.simulator && (this.model.simulator.id !== this.originalState.simulator.id))
        || !this.compareTeams(this.model.teams, this.originalState.teams)
      ) {
        return {
          text: 'UNSAVED',
          type: 'warning',
        };
      }
      return {
        text: 'SAVED',
        type: 'secondary',
      };
    },
  },
  methods: {
    compareTeams(teamsOne, teamsTwo) {
      const teamsOneIds = teamsOne.map(team => team.id);
      const teamsTwoIds = teamsTwo.map(team => team.id);
      if (teamsOneIds.length === teamsTwoIds.length) {
        let match = true;
        teamsOneIds.forEach((id) => {
          if (!teamsTwoIds.includes(id)) {
            match = false;
          }
        });
        return match;
      }
      return false;
    },
    canDrop(to) {
      return to.el.children.length < 2;
    },
    setModelToMatch() {
      console.log(this.originalState);
      if (this.originalState.id !== null || this.originalState.id !== '') {
        this.model.matchDateTime = this.originalState.matchDateTime;
        this.model.simulator = this.originalState.simulator;
        this.model.teams = this.originalState.teams;
        this.model.id = this.originalState.id;
      } else {
        this.model.id = null;
        this.model.matchDateTime = this.week ? new Date(this.week.Start) : null;
        this.model.simulator = 0;
        this.model.teams = [];
      }
    },
    save() {
      if (!this.model.id) {
        this.create();
      } else {
        this.update();
      }
    },
    create() {
      const newMatch = {
        teams: this.model.teams,
        week: this.week.id,
        matchDateTime: this.model.matchDateTime,
      };
      if (this.model.simulator !== null && this.model.simulator !== '') {
        newMatch.simulator = this.model.simulator;
      }
      console.log(newMatch);
      this.axios
        .post('/matches', newMatch, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.originalState.matchDateTime = this.model.matchDateTime;
          this.originalState.simulator = this.model.simulator;
          this.originalState.teams = this.model.teams;
          this.originalState.id = response.data.id;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    update() {
      const newMatch = {
        teams: this.model.teams,
        week: this.week.id,
        matchDateTime: this.model.matchDateTime,
      };
      if (this.model.simulator !== null && this.model.simulator !== '') {
        newMatch.simulator = this.model.simulator;
      }
      this.axios
        .put(`/matches/${this.model.id}`, newMatch, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.originalState.matchDateTime = this.model.matchDateTime;
          this.originalState.simulator = this.model.simulator;
          this.originalState.teams = this.model.teams;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    onRemove() {
      this.$emit('onRemove', this.model.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.player-card{
  overflow: visible;
}
.delete-icon{
  transition: all .25s;
  cursor: pointer;

  &:hover{
    color: #f5365c;
  }
}
.expand-icon {
  margin-left: 1rem;
  cursor: pointer;
}

.light-text{
  font-weight: normal;
}
.drop-grid{
  position: relative;
}

.drop-guides{
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  align-items: center;
  justify-content: center;

  &.single {
    grid-template-columns:  1fr;
  }

  .child {
    pointer-events: none;
    border: 1px dashed #cccccc;
    border-radius: 5px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    color: #cccccc;
    font-size: .9rem;

    &.occupied{
      opacity: 0;
      visibility: hidden;
    }
  }
}
.team-drop-zone{
  width: 100%;
  min-height: 5rem;
  transition: all .25s;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;

  &.single {
    grid-template-columns:  1fr;
  }

  &.occupied{
    border-color: rgba(0,0,0,0);
  }
}
.team-object{
  width: 100%;
}
.status-badge{
  margin-left: 1rem;
}
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }

  .multiselect{
    min-height: 43px;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    border: 0 !important;
    border-radius: 0.375rem;


    .multiselect__tags{
      min-height: 43px;
      padding-top: 12px;
      border: 0;
      color:#8898aa;

    }

    .multiselect__single{
      font-size: .875rem;
    }

    .multiselect__select{
      padding-top: 13px;
    }
  }
</style>
